import { useState } from "react";
import { URLS } from "../config/url";
import { useNavigate } from "react-router-dom";

export const usePasswordReset = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [message, setMessage] = useState(null);

  const forgotPassword = async (email) => {
    setLoading(true);
    setError(null);
    setMessage(null);

    console.log("email", email);
    try {
      const response = await fetch(`${URLS}/api/user/forgotPassword`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ email }),
      });

      if (!response.ok) {
        throw new Error(`Forgot password failed: ${response.statusText}`);
      }

      const data = await response.json();

      //   console.log("data", data);
      //   const accessTokenExpires = Date.now() + 3 * 60 * 1000; // 3 minutes in milliseconds
      //   localStorage.setItem("accessToken", data.accessToken);
      //   localStorage.setItem("refreshToken", data.refreshToken);
      //   localStorage.setItem("accessTokenExpires", accessTokenExpires.toString());
      //   localStorage.setItem("userEmail", data.email);
      setMessage(`Reset password email has been sent to ${email}`);

      setTimeout(() => navigate("/"), 2000);
      // navigate;
      return data;
    } catch (error) {
      setError(error.message);
    } finally {
      setLoading(false);
    }
  };

  const resetPassword = async (token, password) => {
    setLoading(true);
    setError(null);
    setMessage(null);

    try {
      const response = await fetch(`${URLS}/api/user/resetPassword/${token}`, {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ password }),
      });

      const data = await response.json();

      if (!response.ok) {
        throw new Error(data.message || "Password reset failed");
      }

      setMessage("Password reset successful! You can now log in.");
      const accessTokenExpires = Date.now() + 3 * 60 * 1000; // 3 minutes in milliseconds
      localStorage.setItem("accessToken", data.accessToken);
      localStorage.setItem("refreshToken", data.refreshToken);
      localStorage.setItem("accessTokenExpires", accessTokenExpires.toString());
      localStorage.setItem("userEmail", data.email);
      //   setTimeout(() => navigate("/"), 2000);
      return data;
    } catch (error) {
      setError(error.message);
    } finally {
      setLoading(false);
    }
  };

  return { loading, error, message, forgotPassword, resetPassword };
};
